import { render, staticRenderFns } from "./Item4.vue?vue&type=template&id=376b55d8&scoped=true&"
import script from "./Item4.vue?vue&type=script&lang=js&"
export * from "./Item4.vue?vue&type=script&lang=js&"
import style0 from "./Item4.vue?vue&type=style&index=0&id=376b55d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b55d8",
  null
  
)

export default component.exports